import React from "react";
import { Modal, Tabs } from "antd";

import RateExcelUpload from "./RateExcelUpload";
import ManualRateForm from "./ManualRateForm";
import { useTranslation } from "../../i18n/LanguageProvider";

/**
 * Add dialog of the Ханш module.
 *
 * Both ways of adding data live in the one module page, so the sidebar keeps a single entry.
 * Only users with the ADD permission can open it, and the backend enforces the same rule.
 */
function RateAddModal({ open, institutionOptions = [], onClose, onSaved }) {
    const { t } = useTranslation();

    const handleSaved = () => {
        onSaved?.();
        onClose?.();
    };

    const items = [
        {
            key: "excel",
            label: t("add.tab.excel"),
            children: <RateExcelUpload onImportSuccess={handleSaved} />,
        },
        {
            key: "manual",
            label: t("add.tab.manual"),
            children: (
                <ManualRateForm institutionOptions={institutionOptions} onSaved={handleSaved} />
            ),
        },
    ];

    return (
        <Modal
            title={t("rate.add.modalTitle")}
            open={open}
            onCancel={onClose}
            width={1080}
            footer={null}
            destroyOnClose
        >
            <Tabs defaultActiveKey="excel" items={items} />
        </Modal>
    );
}

export default RateAddModal;
